import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { GenericSelect, GenericSelectOption } from "../../shared/GenericSelect";
import { CheckboxMultipleSettings } from "./customPropertyConfig";
import { Check } from "lucide-react";
import { AppCustomPropertyError } from "./AppCustomPropertyError";

type AppCustomPropertyCheckboxMultipleProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyCheckboxMultiple = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyCheckboxMultipleProps) => {

    const [choices, setChoices] = useState<Map<string, boolean>>(data ? new Map(data.map((choice: string) => [choice, true])) : new Map());

    const settings = JSON.parse(customProperty.settings || "{}") as CheckboxMultipleSettings;

    // useEffect(() => {
    //     if (data) {
    //         const newChoices = new Map<string, boolean>();
    //         data.forEach((choice: string) => {
    //             newChoices.set(choice, true);
    //         });
    //         setChoices(newChoices);
    //     }
    // }, [data]);

    useEffect(() => {    
        const data = Array.from(choices.keys()).filter((key) => choices.get(key));
        onChange(customProperty.label, data);
    }, [choices]);

    const atLeastOneChecked = Array.from(choices.values()).some((value) => value);

    const sortedChoices = settings.alphabetize ? 
        settings.choices.sort((a: string, b: string) => a.localeCompare(b)) : settings.choices;

    return (
        <div className="app-custom-property-multiple">
            <div className="app-custom-property-value">
                <div 
                    className="app-custom-property-multiple-choices"
                >
                    {sortedChoices.map((choice: string) => {
                        return (
                            <div 
                                key={choice}
                                className="app-custom-property-multiple-choice"
                            >
                                <input 
                                    type="checkbox"
                                    disabled={disabled}
                                    name={customProperty.label}
                                    checked={choices.get(choice) || false}
                                    onChange={(event) => {
                                        const newChoices = new Map(choices);
                                        newChoices.set(choice, event.target.checked);
                                        setChoices(newChoices);
                                    }}
                                />
                                {choice}
                            </div>
                        )
                        })
                    }
                    <AppCustomPropertyError 
                        flagRequired={validate && customProperty.required && !atLeastOneChecked}
                    />
                    {/* {validate && customProperty.required && !settings.allowNone && !atLeastOneChecked &&
                        <AppCustomPropertyError />
                    }  */}
                </div>
            </div>
        </div>
    )
}
